export default "__VITE_ASSET__DnKaCTw3__"